import React from 'react';

const SvgBw = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BW_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BW_svg__b" fill="#fff">
        <use xlinkHref="#BW_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BW_svg__a" />
      <path
        fill="#8BBDEA"
        mask="url(#BW_svg__b)"
        d="M0 0h28v6.667H0zM0 13.333h28V20H0z"
      />
      <path fill="#FFF" mask="url(#BW_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path fill="#262626" mask="url(#BW_svg__b)" d="M0 8h28v4H0z" />
    </g>
  </svg>
);

export default SvgBw;
